export { RegionalCardDetail } from "./RegionalCardDetail";
